import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/receipt/$receiptId")({
  head: () => ({
    meta: [{ title: "Receipt · Glider" }],
  }),
});
